module.exports = __webpack_public_path__ + "static/media/wtr-book-cover.569b9bf1.png";